import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=32352bcb&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=32352bcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32352bcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32352bcb')) {
      api.createRecord('32352bcb', component.options)
    } else {
      api.reload('32352bcb', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=32352bcb&scoped=true&", function () {
      api.rerender('32352bcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j2ErrNOOJZ0V/JS/comp/CookieBox.vue"
export default component.exports